// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","feedback":"Footer_feedback__1RgpY","link":"Footer_link__3Ie8d"};